import React from 'react';
import SingleColumn from '@templates/SingleColumn';
import NumberList from '@components/NumberList';
import { H2 } from '@heading';

export default function ProspectiveStudents() {
  return (
    <SingleColumn h1="Prospective Students">
      <p style={{ maxWidth: 840 }}>
        If you are a prospective postdoc or student and are interested in
        applying for a fellowship or grant to work together, please:
      </p>
      <NumberList>
        <li>
          <H2>Look at deadlines</H2>
          <p>
            For example, for undergraduates through UCLA's{' '}
            <a href="http://sciences.ugresearch.ucla.edu/">
              Undergraduate Research Center
            </a>
            , and for graduate students and postdocs through the{' '}
            <a href="https://grad.ucla.edu/funding/#/">UCLA database</a>.
          </p>
        </li>
        <li>
          <H2>Review some of our papers</H2>
          <p>
            You can find examples of our research on{' '}
            <a href="https://scholar.google.com/citations?user=FKs1xskAAAAJ">
              Google Scholar
            </a>{' '}
            and{' '}
            <a href="https://www.researchgate.net/institution/University_of_California_Los_Angeles/department/Department_of_Earth_and_Space_Sciences_ESS">
              ResearchGate
            </a>
            .
          </p>
        </li>
        <li>
          <h2>Contact the lab</h2>
          <p>
            You can reach us by email at{' '}
            <a href="mailto:atripati@g.ucla.edu">atripati@g.ucla.edu</a>.
          </p>
        </li>
      </NumberList>
    </SingleColumn>
  );
}
